module.exports = __webpack_public_path__ + "static/img/2-de01bd49f0.cb4251d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/2-de01bd49f0.png
// module id = 4iJ0
// module chunks = 1